/* eslint-disable react/no-did-update-set-state */
/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useContext } from 'react'
import { node } from 'prop-types'
import { sum } from 'lodash'

import axios from 'axios'
import squatchApi from 'lib/squatchApi'

import NativeAuthContext from 'components/NativeAuth'
import CheckoutContext from 'contexts/Checkout'

const Context = React.createContext({})

const SaasquatchProvider = ({ children }) => {
  const { user, token } = useContext(NativeAuthContext)
  const { authSdk, checkout, removeCredit } = useContext(CheckoutContext)
  const [squatch, setSquatch] = useState(null)
  const [saasquatchUser, setSaasquatchUser] = useState(null)
  const [referralCookie, setReferralCookie] = useState(null)
  const [shareUrl, setShareUrl] = useState(null)
  const [rewards, setRewards] = useState([])
  const [totalEarned, setTotalEarned] = useState(null)
  const [totalSpent, setTotalSpent] = useState(null)
  const [totalAvailable, setTotalAvailable] = useState(null)
  const [eligible, setEligible] = useState(null)

  useEffect(() => {
    importSquatch()
  }, [])

  useEffect(() => {
    if (squatch) {
      init()
      fetchReferralCookie()
    }
  }, [squatch])

  useEffect(() => {
    if (user) {
      const isEligible = user.orders.filter(o => o.shopifyData.financial_status === 'paid').length > 0
      setEligible(isEligible)

      if ((authSdk, token)) {
        fetchRewards()
      }
    }
  }, [user, authSdk, token])

  useEffect(() => {
    if (eligible) {
      fetchShareUrl()
    }
  }, [eligible])

  useEffect(() => {
    if (Number(checkout?.subtotalPrice) < 45 && totalSpent === 0) {
      removeCredit()
    }
  }, [checkout])

  const importSquatch = async () => {
    var tempSquatch = await import('@saasquatch/squatch-js')
    setSquatch(tempSquatch)
  }

  const init = async () => {
    squatch.init({ tenantAlias: process.env.GATSBY_SQUATCH_TENANT_ALIAS })
    setTimeout(() => {
      localStorage.debug = ''
    }, 1000)
  }

  const fetchReferralCookie = async () => {
    const { codes } = await squatch.api().squatchReferralCookie()
    setReferralCookie(codes[process.env.GATSBY_SQUATCH_PROGRAM_ID])
  }

  const fetchShareUrl = async () => {
    try {
      const { data } = await squatchApi.get(
        `/open/account/${user.id}/user/${user.id}/shareurls?programId=${process.env.GATSBY_SQUATCH_PROGRAM_ID}`
      )
      setShareUrl(data.shareLinks.HOSTED.DIRECT)
    } catch (e) {
      console.log(e)
    }
  }

  const fetchRewards = async () => {
    try {
      const response = await authSdk.getSaasquatchRewards(token)
      setRewards(response.rewards)

      const { rewardsBalance } = await authSdk.getSaasquatchRewardsBalance(token)

      if (rewardsBalance) {
        setTotalEarned((rewardsBalance.totalAssignedCredit + rewardsBalance.totalExpiredCredit) / 100)
        setTotalSpent(rewardsBalance.totalRedeemedCredit / 100)
        setTotalAvailable((rewardsBalance.totalAssignedCredit - rewardsBalance.totalRedeemedCredit) / 100)
      } else {
        setTotalEarned(0)
        setTotalSpent(0)
        setTotalAvailable(0)
      }
    } catch (e) {
      console.log(e)
    }
  }

  const value = {
    saasquatchUser,
    shareUrl,
    referralCookie,
    totalEarned,
    totalSpent,
    totalAvailable,
    rewards,
    eligible
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

SaasquatchProvider.propTypes = {
  children: node
}

const { Consumer } = Context
export { Consumer as SaasquatchConsumer, SaasquatchProvider }

export default Context
